module.exports = __webpack_public_path__ + "img/9.3e80d406.png";